// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".success{margin:0.5rem 0 !important;color:#00ad5c}\n", ""]);
// Exports
module.exports = exports;
